<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 384 384"
        width="24"
        height="24"
        fill="currentColor"
    >
        <g transform="translate(0,384) scale(0.1,-0.1)" stroke="none">
            <path
                d="M1290 2545 l-1255 -1255 628 -627 627 -628 1257 1257 1258 1258 -290 290 -290 290 -174 -174 -175 -175 22 -48 c84 -182 13 -389 -165 -479 -52 -26 -68 -29 -153 -29 -82 0 -103 4 -151 26 -79 37 -133 90 -171 167 -30 61 -33 75 -33 162 0 85 3 101 29 153 90 178 297 249 479 165 l48 -22 174 174 175 175 -287 287 c-159 159 -290 288 -293 288 -3 0 -570 -565 -1260 -1255z"
            />
        </g>
    </svg>
</template>

<script>
export default { name: "TagIcon" };
</script>
